import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";
import { useNavigate } from "react-router";

import { ApiError } from "@shared/types";
import { Book } from "@modules/books/types";
import { BookFormValues } from "@modules/books/validations";
import requestErrorTreatment from "@shared/utils/requestErrorTreatment";

import { createBookService } from "./service";
import { UseCreateBookMutationOptions } from "./types";
import { listBooksQueryKey } from "../../queries/listBooks/query";

export function useCreateBookMutation(
  options?: UseCreateBookMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<Book, ApiError, BookFormValues>({
    mutationFn: createBookService,
    onSuccess: (book: Book) => {
      queryClient.invalidateQueries({
        queryKey: listBooksQueryKey,
        refetchType: "all",
      });

      open?.({
        type: "success",
        message: translate("v1/book_admin.success.create"),
      });

      navigate(`/books/edit/${book.id}`);
    },
    onError: (error: ApiError) => {
      requestErrorTreatment(error, open);
    },
    ...options,
  });
}
